<template>
  <a
    :href="trabalho.href"
    :target="trabalho.target"
    class="trabalho"
    v-if="trabalho">
    <div class="trabalho-nome">{{trabalho.titulo}}</div>
    <small class="trabalho-eixo">
      <router-link :to="{name:'trabalhos', params:{pesquisa:trabalho.eixo.nome}}">
        <b>{{trabalho.eixo.nome}}</b>
      </router-link>
    </small>
    <div class="trabalho-autores">
      <template v-for="(a, index) in trabalho.todos_autores">
        <span v-if="index != 0"> ; </span>
        <router-link :to="'/autor/'+a.id" class="trabalho-autor">{{a.nome}}</router-link>
      </template>
    </div>
    <small class="trabalho-palavras-chaves" v-if="trabalho.palavras_chaves.length">
      <template v-for="(p, index) in trabalho.palavras_chaves">
        <template v-if="index!=0">, </template>
        <router-link :to="{name:'trabalhos', params:{pesquisa:p.palavra_chave}}">
          {{p.palavra_chave}}
        </router-link>
      </template>
    </small>
    <div class="trabalho-id">{{trabalho.id}}</div>
  </a>
</template>

<script>
import Vue from 'vue'
import removeAccents from 'remove-accents'
import { i18n } from '@/langs/anais'

export default {
  name: 'anaisTrabalhoRow',
  props: ['trabalho_id'],
  components: {},
  data () {
    return {};
  },
  filters: {},
  watch: {},
  computed: {
    trabalho() {
      return this.trabalhos.find(t => t.id == this.trabalho_id)
    },
    // eu preciso fazer um computed
    // pq eu qro acessar essas variáveis diretamente do <template>
    eixos() { return eixos }, autores() { return autores }, palavras_chaves() { return palavras_chaves }, trabalhos() { return trabalhos },
  },
  created: function () {},
  mounted: function () {},
  methods: {},
  i18n: i18n
}
</script>

<style scoped>
/*cada linha de trabalhos t*/
.trabalho a, a.trabalho {
  color: unset;
}
.trabalho a:hover, a:hover.trabalho {
  color: unset;
  text-decoration: unset;
}
.trabalho {
  position: relative;
  display: block;
  border: 1px solid #CCC;
  border-left: 7px solid #333;
  margin: 10px 0;
  box-shadow: 1px 1px 1px #CCC;
  padding: 10px;
}
.trabalho-eixo {
  display: block;
  margin-bottom: 7px;
}
.trabalho-autor {
  font-size: 90%;
  text-decoration: underline;
  display: inline-block;
  color: #eb593c !important;
}
.trabalho-id {
  position: absolute;
  right: -1px;
  bottom: -1px;
  border: 1px solid #CCC;
  border-radius: 2px;
  font-family: monospace;
}
</style>


// WEBPACK FOOTER //
// AnaisTrabalhoRow.vue?49ebaa4e